import { z } from 'zod';
/**
 * Captura de e-mail do funil da landing (`apps/site`). Não é o cadastro do
 * produto — é só a lista de quem quer ser avisado quando ele abrir, ou
 * receber novidade. Ver `docs/superpowers/specs/2026-08-26-specializer-social-design.md`.
 *
 * De onde a pessoa veio, para o funil saber o que converteu:
 *  - `auditoria`  — logo depois de ver o laudo da auditoria grátis;
 *  - `planos`     — na seção de planos;
 *  - `cta-final`  — no CTA final da página.
 */
export const ORIGENS_INTERESSE = ['auditoria', 'planos', 'cta-final'];
export const origemInteresseSchema = z.enum(ORIGENS_INTERESSE);
/**
 * Apara espaço e baixa a caixa. `Joao@X.com` e `joao@x.com ` são a mesma
 * pessoa, e a idempotência por e-mail (`InteresseService.registrar`) depende
 * de comparar sempre a MESMA forma normalizada — nunca o que a pessoa digitou.
 */
export function normalizarEmail(email) {
    return email.trim().toLowerCase();
}
/**
 * Mesmo padrão de `soDigitosSchema` (`redacao/formato.ts`): normaliza dentro
 * do schema, para que toda porta de entrada normalize igual. `InteresseService`
 * chama `normalizarEmail` de novo antes de gravar — cobre quem monta o DTO na
 * mão (seed, script, teste) sem passar pelo `.parse()`.
 */
export const emailInteresseSchema = z
    .string()
    .transform(normalizarEmail)
    .pipe(z.string().email('Informe um e-mail válido.'));
/**
 * Texto exato do que a pessoa aceita ao marcar o checkbox. Fica também
 * gravado na linha (`interessado.consentimento_texto`, coluna, não
 * referência) — consentimento que não se prova não vale nada (LGPD art. 8º),
 * e o texto muda com o tempo: a linha tem de guardar a versão que ELA aceitou,
 * não a versão atual. Front e back leem esta MESMA constante.
 */
export const TEXTO_CONSENTIMENTO_INTERESSE = 'Aceito receber novidades sobre o Specializer Social por e-mail, incluindo o aviso de quando o cadastro abrir.';
/**
 * Checkbox tem de estar marcado — `false` ou ausente é entrada inválida, não
 * "não, obrigado" silencioso. Caixa pré-marcada não é consentimento (LGPD
 * art. 7º, I); o campo existir e valer `true` é o que essa marcação vira aqui.
 */
export const registrarInteresseSchema = z.object({
    email: emailInteresseSchema,
    origem: origemInteresseSchema,
    consentimento: z
        .boolean()
        .refine((v) => v === true, 'É preciso aceitar para continuar.'),
});
/**
 * Descadastro por e-mail OU por token opaco (gravado em cada linha na
 * captura, para um futuro link de e-mail — nenhum e-mail é disparado hoje).
 * Os dois braços do `union` respondem IGUAL quando não encontram nada: ver
 * `InteresseService.sair`.
 */
export const sairInteresseSchema = z.union([
    z.object({ email: emailInteresseSchema, token: z.undefined().optional() }),
    z.object({ token: z.string().min(16), email: z.undefined().optional() }),
]);
//# sourceMappingURL=interesse.js.map